import request from '@/utils/request'

const api = {
  Query(data) {
    return request({
      url: 'admin/article/list',
      method: 'post',
      data
    })
  },
  Delete(data) {
    return request({
      url: 'admin/article/destroy',
      method: 'post',
      data
    })
  },
  Update(data) {
    return request({
      url: 'admin/article/createOrUpdate',
      method: 'post',
      data
    })
  },
  Create(data) {
    return request({
      url: 'admin/article/createOrUpdate',
      method: 'post',
      data
    })
  },
  Detail(id) {
    return request({
      url: 'admin/article/detail',
      method: 'post',
      params: { id }
    })
  },
  Copy(id) {
    return request({
      url: 'admin/article/copy',
      method: 'post',
      params: { id }
    })
  }
}

export default api
